<div class="border-card border-0 px-4 py-1 scroll-container" ref="ViewEntityType">
  <NavigationBackButton />
  <div class="card card-nav-tabs mt-5 rounded-lg border-0 shadow">
    <div class="card-header card-header-primary shadow rounded-lg">
      <div class="nav-tabs-navigation">
        <div class="nav-tabs-wrapper">
          <ul class="nav nav-tabs" data-tabs="tabs">
            <li
              class="nav-item"
              v-for="(tab, index) in tabs"
              :key="index"
              :class="[ active_tab === tab ? 'active' : '' ]"
              @click="set_active_tab(tab)"
            >
              <a
                class="text-dark text-decoration-none text-x nav-link"
                href="#profile"
                data-toggle="tab"
              >
                {{ tab }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

      <div v-if="active_tab === 'IDV Results'">
        <div class="text-center py-4 text-xxs text-muted">
          <IdentityVerificationResults/>
        </div>
      </div>


      <div v-if="active_tab === 'CPIC Results'">
        <div class="text-center py-4 text-xxs text-muted">CPIC Results management coming soon</div>
      </div>

      <div v-if="active_tab === 'Directors Results'">
        <div class="text-center py-4 text-xxs text-muted">Directors Results management coming soon</div>
      </div>

      <div v-if="active_tab === 'Address search'">
        <div class="text-center py-4 text-xxs text-muted">Address search coming soon</div>
      </div>
  </div>
</div>

